import { GetJpaOrgData } from '@api/services/jpa/types';
import { NprResultTypes } from '@src/utils/enums';
import {
  handleCreateRequest,
  handleDownloadLetter,
  ResultLetterDownload,
  ResultRequests,
} from '../../components/modals/self-verify-result/selfVerifyResultHelper';

const cancelMessage = (
  <div className='margin-top-1'>
    Click the <b>Cancel</b> button to exit back to RRS (your use of this tool has already been noted).
  </div>
);

export const nprOutcomes = [
  NprResultTypes.NprExemption,
  NprResultTypes.NprLetter,
  NprResultTypes.PermitRequired,
  NprResultTypes.PreApplication,
  NprResultTypes.JurisdictionalDetermination,
] as const;

export const getNprOutcomeContent = ({ orgData }: { orgData: GetJpaOrgData | undefined }) => ({
  [NprResultTypes.NprExemption]: {
    content: (
      <>
        Based on the information provided, your project qualifies for a 404(f) Exemption. Click the{' '}
        <b>Download Letter</b> button below to obtain your letter.
        {cancelMessage}
      </>
    ),
    onSave: () => handleDownloadLetter(ResultLetterDownload.NprExemption),
    saveText: 'Download Letter',
    title: 'Your project does not require a Permit',
  },

  [NprResultTypes.NprLetter]: {
    content: (
      <>
        Based on the information provided, your project does not require a Permit. Click the <b>Download Letter</b>{' '}
        button below to obtain your letter.
        {cancelMessage}
      </>
    ),
    onSave: () => handleDownloadLetter(ResultLetterDownload.NprLetter),
    saveText: 'Download Letter',
    title: 'Your project does not require a Permit',
  },

  [NprResultTypes.PermitRequired]: {
    content: (
      <>
        Instead, the next suggested step for your project is a Permit request. Click the <b>Create Request</b> button
        below to create an Application for Department of the Army (DA) Permit request.
        {cancelMessage}
      </>
    ),
    onSave: () => handleCreateRequest(ResultRequests.PermitRequired, orgData),
    saveText: 'Create Request',
    title: 'Based on the information provided, your project does not qualify for a No Permit Required outcome',
  },

  [NprResultTypes.PreApplication]: {
    content: (
      <>
        Instead, the next suggested step for your project is a Pre-application Meeting. Click the <b>Create Request</b>{' '}
        button below to create a Pre-application / Project Scoping request.
        {cancelMessage}
      </>
    ),
    onSave: () => handleCreateRequest(ResultRequests.PreApplication, orgData),
    saveText: 'Create Request',
    title: 'Based on the information provided, your project does not qualify for a No Permit Required outcome',
  },

  [NprResultTypes.JurisdictionalDetermination]: {
    content: (
      <>
        Instead, the next suggested step for your project is a Jurisdictional Determination. If you believe your project
        may occur outside of USACE geographically regulated waters and are requesting confirmation to that effect,
        please request a Jurisdiction Determination by clicking the <b>Create Request</b> button below. You may also
        contact your district for a No Permit Required letter for geographic Jurisdiction.
        {cancelMessage}
      </>
    ),
    onSave: () => handleCreateRequest(ResultRequests.JurisdictionalDetermination, orgData),
    saveText: 'Create Request',
    title: 'Based on the information provided, your project does not qualify for a No Permit Required outcome',
  },
});
